import React from 'react';
import styled from 'styled-components';
import { red } from 'core/styles';

const Title = styled.h1`
  font-size: 2rem;
  color: ${red};
  text-align: center; // web specific
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleStyled = styled.h1`
  font-size: 2vw;
  text-align: center;
  padding: 0 1vw;
  margin: 0;
  flex: 0;
  line-height: 2vw;
`;

export const TitleText = ({ children, ...rest }) => {
  return (
    <TitleContainer>
      <TitleStyled>{'-'}</TitleStyled>
      <TitleStyled>{children.toLocaleUpperCase()}</TitleStyled>
      <TitleStyled>{'-'}</TitleStyled>
    </TitleContainer>
  );
};

export default Title;
